import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_pluginutils_ff222d6c from 'nuxt_plugin_pluginutils_ff222d6c' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginseo_0e8ca71e from 'nuxt_plugin_pluginseo_0e8ca71e' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_534b67d6 from 'nuxt_plugin_pluginrouting_534b67d6' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7e971f7a from 'nuxt_plugin_pluginmain_7e971f7a' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_0d0ea911 from 'nuxt_plugin_axios_0d0ea911' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_indexclient_1d58cd8a from 'nuxt_plugin_indexclient_1d58cd8a' // Source: ../../../../../shared/all/plugins/webCoreVital/index.client.js (mode: 'client')
import nuxt_plugin_polyfillsclient_7828a376 from 'nuxt_plugin_polyfillsclient_7828a376' // Source: ../../../../../shared/all/plugins/config/polyfills.client.js (mode: 'client')
import nuxt_plugin_persistedStateclient_63f8a28e from 'nuxt_plugin_persistedStateclient_63f8a28e' // Source: ../../../../../shared/all/plugins/config/persistedState.client.js (mode: 'client')
import nuxt_plugin_contextclient_751ce3f0 from 'nuxt_plugin_contextclient_751ce3f0' // Source: ../../../../../shared/all/plugins/config/context.client.js (mode: 'client')
import nuxt_plugin_globalfunctions_f7387b92 from 'nuxt_plugin_globalfunctions_f7387b92' // Source: ../../../../../shared/all/plugins/global.functions.js (mode: 'all')
import nuxt_plugin_globalcomponents_1b14d674 from 'nuxt_plugin_globalcomponents_1b14d674' // Source: ../../../../../shared/all/plugins/global.components.js (mode: 'all')
import nuxt_plugin_eventbus_42ab53f4 from 'nuxt_plugin_eventbus_42ab53f4' // Source: ../../../../../shared/all/plugins/config/eventbus.js (mode: 'all')
import nuxt_plugin_errors_2542c662 from 'nuxt_plugin_errors_2542c662' // Source: ../../../../../shared/all/plugins/config/errors.js (mode: 'all')
import nuxt_plugin_experimentsclient_913d17d2 from 'nuxt_plugin_experimentsclient_913d17d2' // Source: ../../../../../shared/all/plugins/config/experiments.client.js (mode: 'client')
import nuxt_plugin_absmartlyclient_7e4d8bd6 from 'nuxt_plugin_absmartlyclient_7e4d8bd6' // Source: ../../../../../shared/all/plugins/config/absmartly.client.js (mode: 'client')
import nuxt_plugin_usercentrics_5b05af42 from 'nuxt_plugin_usercentrics_5b05af42' // Source: ../../../../../shared/all/plugins/config/usercentrics.client (mode: 'client')
import nuxt_plugin_analyticsclient_55b1ec47 from 'nuxt_plugin_analyticsclient_55b1ec47' // Source: ../../../../../shared/all/plugins/config/analytics.client.js (mode: 'client')
import nuxt_plugin_metaclient_2c003540 from 'nuxt_plugin_metaclient_2c003540' // Source: ../../../../../shared/all/plugins/config/meta.client.js (mode: 'client')
import nuxt_plugin_microsoftadsclient_6ffd5cd2 from 'nuxt_plugin_microsoftadsclient_6ffd5cd2' // Source: ../../../../../shared/all/plugins/config/microsoft-ads.client.js (mode: 'client')
import nuxt_plugin_hubspotclient_34151fb8 from 'nuxt_plugin_hubspotclient_34151fb8' // Source: ../../../../../shared/all/plugins/config/hubspot.client.js (mode: 'client')
import nuxt_plugin_gtmclient_4ead6fa1 from 'nuxt_plugin_gtmclient_4ead6fa1' // Source: ../../../../../shared/all/plugins/config/gtm.client.js (mode: 'client')
import nuxt_plugin_hotjarclient_3df05b89 from 'nuxt_plugin_hotjarclient_3df05b89' // Source: ../../../../../shared/all/plugins/config/hotjar.client.js (mode: 'client')
import nuxt_plugin_clarityclient_00445415 from 'nuxt_plugin_clarityclient_00445415' // Source: ../../../../../shared/all/plugins/config/clarity.client.js (mode: 'client')
import nuxt_plugin_pageTimeTrackerclient_7232b5ca from 'nuxt_plugin_pageTimeTrackerclient_7232b5ca' // Source: ../../../../../shared/all/plugins/pageTimeTracker.client.js (mode: 'client')
import nuxt_plugin_trackClick_517f71bf from 'nuxt_plugin_trackClick_517f71bf' // Source: ../../../../../shared/all/plugins/directives/trackClick.js (mode: 'all')
import nuxt_plugin_trackVisibility_208ccd55 from 'nuxt_plugin_trackVisibility_208ccd55' // Source: ../../../../../shared/all/plugins/directives/trackVisibility.js (mode: 'all')
import nuxt_plugin_queryParamsclient_4cc8eb22 from 'nuxt_plugin_queryParamsclient_4cc8eb22' // Source: ../../../../../shared/all/plugins/config/queryParams.client.js (mode: 'client')
import nuxt_plugin_innerHeight_589344f9 from 'nuxt_plugin_innerHeight_589344f9' // Source: ../../../../../shared/all/plugins/config/innerHeight.client (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"refreshOnceOnNavigation":true,"debounceWait":0,"waitOnDestroyed":false,"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"favicon\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","href":"favicon\u002Ffavicon-16x16.png","sizes":"16x16"},{"rel":"icon","type":"image\u002Fpng","href":"favicon\u002Ffavicon-32x32.png","sizes":"32x32"},{"rel":"icon","type":"image\u002Fpng","href":"favicon\u002Ffavicon-96x96.png","sizes":"96x96"},{"rel":"icon","type":"image\u002Fpng","href":"favicon\u002Ffavicon-128x128.png","sizes":"128x128"},{"rel":"icon","type":"image\u002Fpng","href":"favicon\u002Ffavicon-196x196.png","sizes":"196x196"},{"rel":"apple-touch-icon","href":"favicon\u002Fapple-touch-icon-57x57.png","sizes":"57x57"},{"rel":"apple-touch-icon","href":"favicon\u002Fapple-touch-icon-60x60.png","sizes":"60x60"},{"rel":"apple-touch-icon","href":"favicon\u002Fapple-touch-icon-72x72.png","sizes":"72x72"},{"rel":"apple-touch-icon","href":"favicon\u002Fapple-touch-icon-76x76.png","sizes":"76x76"},{"rel":"apple-touch-icon","href":"favicon\u002Fapple-touch-icon-114x114.png","sizes":"114x114"},{"rel":"apple-touch-icon","href":"favicon\u002Fapple-touch-icon-120x120.png","sizes":"120x120"},{"rel":"apple-touch-icon","href":"favicon\u002Fapple-touch-icon-144x144.png","sizes":"144x144"},{"rel":"apple-touch-icon","href":"favicon\u002Fapple-touch-icon-152x152.png","sizes":"152x152"}],"titleTemplate":"%s | Rijscholenvergelijker.nl","title":"Rijscholenvergelijker.nl","style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_pluginutils_ff222d6c === 'function') {
    await nuxt_plugin_pluginutils_ff222d6c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_0e8ca71e === 'function') {
    await nuxt_plugin_pluginseo_0e8ca71e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_534b67d6 === 'function') {
    await nuxt_plugin_pluginrouting_534b67d6(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7e971f7a === 'function') {
    await nuxt_plugin_pluginmain_7e971f7a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_0d0ea911 === 'function') {
    await nuxt_plugin_axios_0d0ea911(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_indexclient_1d58cd8a === 'function') {
    await nuxt_plugin_indexclient_1d58cd8a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_polyfillsclient_7828a376 === 'function') {
    await nuxt_plugin_polyfillsclient_7828a376(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_persistedStateclient_63f8a28e === 'function') {
    await nuxt_plugin_persistedStateclient_63f8a28e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_contextclient_751ce3f0 === 'function') {
    await nuxt_plugin_contextclient_751ce3f0(app.context, inject)
  }

  if (typeof nuxt_plugin_globalfunctions_f7387b92 === 'function') {
    await nuxt_plugin_globalfunctions_f7387b92(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_1b14d674 === 'function') {
    await nuxt_plugin_globalcomponents_1b14d674(app.context, inject)
  }

  if (typeof nuxt_plugin_eventbus_42ab53f4 === 'function') {
    await nuxt_plugin_eventbus_42ab53f4(app.context, inject)
  }

  if (typeof nuxt_plugin_errors_2542c662 === 'function') {
    await nuxt_plugin_errors_2542c662(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_experimentsclient_913d17d2 === 'function') {
    await nuxt_plugin_experimentsclient_913d17d2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_absmartlyclient_7e4d8bd6 === 'function') {
    await nuxt_plugin_absmartlyclient_7e4d8bd6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_usercentrics_5b05af42 === 'function') {
    await nuxt_plugin_usercentrics_5b05af42(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analyticsclient_55b1ec47 === 'function') {
    await nuxt_plugin_analyticsclient_55b1ec47(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_metaclient_2c003540 === 'function') {
    await nuxt_plugin_metaclient_2c003540(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_microsoftadsclient_6ffd5cd2 === 'function') {
    await nuxt_plugin_microsoftadsclient_6ffd5cd2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hubspotclient_34151fb8 === 'function') {
    await nuxt_plugin_hubspotclient_34151fb8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtmclient_4ead6fa1 === 'function') {
    await nuxt_plugin_gtmclient_4ead6fa1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hotjarclient_3df05b89 === 'function') {
    await nuxt_plugin_hotjarclient_3df05b89(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clarityclient_00445415 === 'function') {
    await nuxt_plugin_clarityclient_00445415(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pageTimeTrackerclient_7232b5ca === 'function') {
    await nuxt_plugin_pageTimeTrackerclient_7232b5ca(app.context, inject)
  }

  if (typeof nuxt_plugin_trackClick_517f71bf === 'function') {
    await nuxt_plugin_trackClick_517f71bf(app.context, inject)
  }

  if (typeof nuxt_plugin_trackVisibility_208ccd55 === 'function') {
    await nuxt_plugin_trackVisibility_208ccd55(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_queryParamsclient_4cc8eb22 === 'function') {
    await nuxt_plugin_queryParamsclient_4cc8eb22(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_innerHeight_589344f9 === 'function') {
    await nuxt_plugin_innerHeight_589344f9(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
